// extracted by mini-css-extract-plugin
export default {"title":"u6-z","warning":"v6-z","sizeOptionsLegendText":"w6-z"};